export default __webpack_public_path__ + "static/media/mongodb-logo.94082411.png";